// Version utility for SIC application
export const APP_VERSION = '1.1.0';
export const APP_NAME = 'SIC';

// Get version info for display
export const getVersionInfo = () => {
  return {
    version: APP_VERSION,
    name: APP_NAME,
    displayText: `v${APP_VERSION}`,
    fullDisplay: `${APP_NAME} v${APP_VERSION}`
  };
};

// Get build timestamp (if available)
export const getBuildInfo = () => {
  const buildTime = process.env.REACT_APP_BUILD_TIME || new Date().toISOString();
  return {
    buildTime,
    version: APP_VERSION,
    environment: process.env.NODE_ENV || 'development'
  };
};
